import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { WorkflowLayout } from 'Components/ComponentLibrary/Organisms/WorkflowLayout/WorkflowLayout';
import { FDContentContainer } from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { LottieLoadingLayout } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';
import { AccountOpeningV2WaitStepLayout } from './layout';
import { metaOverrideSet } from './metaOverrideSet';

export const AccountOpeningV2WaitStepTemplate = ({ resource }) => {
  return (
    <LottieLoadingLayout>
      <WorkflowLayout appearance="elevated" resource={resource}>
        <FDContentContainer maxWidth="sm">
          <MetaResourceRenderer
            metaOverrideSet={metaOverrideSet}
            layout={AccountOpeningV2WaitStepLayout}
            resource={resource}
          />
        </FDContentContainer>
      </WorkflowLayout>
    </LottieLoadingLayout>
  );
};

AccountOpeningV2WaitStepTemplate.defaultProps = {
};

AccountOpeningV2WaitStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
